import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import HotelContextProvider from './Context/HotelContextProvider.jsx';
import CartContextProvider from './CartCon/CartContextProvider.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <HotelContextProvider>
  <CartContextProvider>
  <BrowserRouter>
  <App />
  </BrowserRouter>
  </CartContextProvider>
  </HotelContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
